import React from 'react';

import ReactDOM from 'react-dom';

import './index.css';
import './toast.css';
import 'core/localization/init';
import {App} from 'components/common/App';

import 'models/init';
import {LABELS} from 'core/constants/labels';

import {loadProfileFx} from './models/auth';

document.title = LABELS.name || 'Marking system';

loadProfileFx()
    .catch(console.log)
    .finally(() => {
        ReactDOM.render(<App />, document.getElementById('root'));
    });
